// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","274":"63da7a08","434":"736f8f6c","458":"a65bef60","577":"66801e42","652":"34876035","682":"d5252985","783":"c66ca607","812":"e16e9c63","867":"d00ba839","904":"0c67cfd9","957":"5d0be030","985":"de897744"}[chunkId] + ".js";
};